import React from "react";
import ReactDOM from "react-dom/client";
import "sonner/dist/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { GlobalProvider } from "@/app/providers/GlobalStore";
import "@/index.css";
import ToasterRoot from "@/components/Toaster";
import AppRouter from "./routes";
import { GlobalProvider } from "./context/Provider";
import { ThemeProvider } from "@/components/theme-provider";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<GlobalProvider>
				<ThemeProvider>
					<AppRouter />
					<ToasterRoot />
				</ThemeProvider>
			</GlobalProvider>
		</QueryClientProvider>
	</React.StrictMode>
);
